import React from 'react';
import { Row, Col, FormGroup, Label, Input } from 'reactstrap';
import { KECAMATAN, getDesaByKecamatan } from '../../datarecap/constants';

const MANUAL_JENIS = [
  { value: 'Rehab Rumah Tidak Layak Huni', nominal: 30000000, nominalMaterial: 0, nominalUpahKerja: 0 },
  { value: 'Pembangunan Rumah Layak Huni', nominal: 50000000, nominalMaterial: 40000000, nominalUpahKerja: 10000000 },
];

const ManualBantuanFields = ({ form, setForm, tflList = [], agrList = [], supplierList = [], isTfl = false }) => {
  const onJenisChange = (value) => {
    const item = MANUAL_JENIS.find((j) => j.value === value);
    setForm((p) => ({
      ...p,
      JenisBantuan: value,
      nominal: item?.nominal ?? p.nominal,
      nominalMaterial: item?.nominalMaterial ?? p.nominalMaterial,
      nominalUpahKerja: item?.nominalUpahKerja ?? p.nominalUpahKerja,
    }));
  };

  return (
    <>
      <Row>
        <Col md={6}>
          <FormGroup>
            <Label className="fw-semibold">Nama Lengkap Penerima</Label>
            <Input
              value={form.namaLengkap || ''}
              onChange={(e) => setForm((p) => ({ ...p, namaLengkap: e.target.value }))}
              required
            />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label className="fw-semibold">Nomor KK</Label>
            <Input
              value={form.nomorKK || ''}
              onChange={(e) => setForm((p) => ({ ...p, nomorKK: e.target.value }))}
            />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label className="fw-semibold">Nomor KTP</Label>
            <Input
              value={form.nomorKTP || ''}
              onChange={(e) => setForm((p) => ({ ...p, nomorKTP: e.target.value }))}
            />
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <FormGroup>
            <Label className="fw-semibold">Alamat Lengkap</Label>
            <Input
              type="textarea"
              rows={2}
              value={form.alamatLengkap || ''}
              onChange={(e) => setForm((p) => ({ ...p, alamatLengkap: e.target.value }))}
            />
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md={4}>
          <FormGroup>
            <Label className="fw-semibold">Kecamatan</Label>
            <Input
              type="select"
              value={form.kecamatan || ''}
              onChange={(e) => setForm((p) => ({
                ...p,
                kecamatan: e.target.value,
                desaKelurahan: '',
              }))}
            >
              <option value="">Pilih Kecamatan</option>
              {KECAMATAN.map((k) => <option key={k} value={k}>{k}</option>)}
            </Input>
          </FormGroup>
        </Col>
        <Col md={8}>
          <FormGroup>
            <Label className="fw-semibold">Desa/Kelurahan</Label>
            <Input
              type="select"
              value={form.desaKelurahan || ''}
              disabled={!form.kecamatan}
              onChange={(e) => setForm((p) => ({ ...p, desaKelurahan: e.target.value }))}
            >
              <option value="">{form.kecamatan ? 'Pilih Desa/Kelurahan' : 'Pilih kecamatan dulu'}</option>
              {getDesaByKecamatan(form.kecamatan).map((d) => (
                <option key={d} value={d}>{d}</option>
              ))}
            </Input>
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <FormGroup>
            <Label className="fw-semibold">Jenis Bantuan (SK)</Label>
            <Input type="select" value={form.JenisBantuan} onChange={(e) => onJenisChange(e.target.value)}>
              {MANUAL_JENIS.map((j) => (
                <option key={j.value} value={j.value}>{j.value}</option>
              ))}
            </Input>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label className="fw-semibold">Nominal (otomatis)</Label>
            <Input value={form.nominal ? `Rp ${Number(form.nominal).toLocaleString('id-ID')}` : ''} disabled />
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md={4}>
          <FormGroup>
            <Label className="fw-semibold">TFL Pendamping</Label>
            <Input
              type="select"
              value={form.AdminId || ''}
              disabled={isTfl}
              onChange={(e) => setForm((p) => ({ ...p, AdminId: e.target.value }))}
            >
              {!isTfl && <option value="">(Pilih TFL)</option>}
              {tflList.map((t) => (
                <option key={t.id} value={t.id}>{t.username} — {t.NoWa || '-'}</option>
              ))}
            </Input>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label className="fw-semibold">Toko Supplier</Label>
            <Input
              type="select"
              value={form.supplierId || ''}
              onChange={(e) => setForm((p) => ({ ...p, supplierId: e.target.value }))}
            >
              <option value="">(Pilih toko)</option>
              {supplierList.map((s) => (
                <option key={s.id} value={s.id}>{s.namaToko || s.namaSupplier || `Toko #${s.id}`}</option>
              ))}
            </Input>
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md={4}>
          <FormGroup>
            <Label className="fw-semibold">AGR Pendamping</Label>
            <Input
              type="select"
              value={form.AgrId || ''}
              onChange={(e) => setForm((p) => ({ ...p, AgrId: e.target.value }))}
            >
              <option value="">(Pilih AGR)</option>
              {agrList.map((a) => (
                <option key={a.id} value={a.id}>{a.username} — {a.NoWa || '-'}</option>
              ))}
            </Input>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label className="fw-semibold">Status Kontrak</Label>
            <Input
              type="select"
              value={form.statusKontrak || 'Sudah SK'}
              onChange={(e) => setForm((p) => ({ ...p, statusKontrak: e.target.value }))}
            >
              <option value="Sudah SK">Sudah SK</option>
              <option value="Proses SK">Proses SK</option>
              <option value="Belum SK">Belum SK</option>
            </Input>
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md={4}>
          <FormGroup>
            <Label className="fw-semibold">Nomor SK</Label>
            <Input value={form.nomorSK || ''} onChange={(e) => setForm((p) => ({ ...p, nomorSK: e.target.value }))} />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label className="fw-semibold">Tanggal SK</Label>
            <Input type="date" value={form.tanggalSK || ''} onChange={(e) => setForm((p) => ({ ...p, tanggalSK: e.target.value }))} />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label className="fw-semibold">Tanggal Input Bantuan</Label>
            <Input type="date" value={form.tanggalBantuan || ''} onChange={(e) => setForm((p) => ({ ...p, tanggalBantuan: e.target.value }))} />
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <FormGroup>
            <Label className="fw-semibold">No. WA Penerima</Label>
            <Input value={form.noWaPenerimaBantuan || ''} onChange={(e) => setForm((p) => ({ ...p, noWaPenerimaBantuan: e.target.value }))} />
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label className="fw-semibold">No. Rekening Penerima</Label>
            <Input value={form.noRekening || ''} onChange={(e) => setForm((p) => ({ ...p, noRekening: e.target.value }))} />
          </FormGroup>
        </Col>
      </Row>
    </>
  );
};

export { MANUAL_JENIS };
export default ManualBantuanFields;